// extracted by mini-css-extract-plugin
export default {"allergens":"allergens_allergens__YRNFf"};